import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/calculator", label: "Calculator" },
  { to: "/learn", label: "Learn" },
  { to: "/work-with-me", label: "Work With Me" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white border-b-2 border-primary/10" data-testid="site-navbar">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 no-underline">
          <img src="/vde-logo-green.png" alt="Veterans Disability Education" className="h-10 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[15px] font-semibold ${isActive ? "text-primary underline underline-offset-8 decoration-2 decoration-accent" : "text-primary/80 hover:text-primary"}`
              }>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user && user.role === "admin" ? (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-admin" onClick={() => navigate("/admin")}>Admin</Button>
              <Button variant="outline" size="sm" data-testid="nav-logout" onClick={async () => { await logout(); navigate("/"); }}>Log out</Button>
            </>
          ) : user ? (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/portal")} data-testid="nav-portal">My Portal</Button>
              <Button variant="outline" size="sm" onClick={async () => { await logout(); navigate("/"); }} data-testid="nav-logout">Log out</Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="hidden sm:inline-flex text-[15px] font-semibold text-primary hover:underline underline-offset-4">Log in</Link>
              <Button size="default" data-testid="nav-cta" onClick={() => navigate("/intake")}>
                Free Consult
              </Button>
            </>
          )}
          <button className="lg:hidden ml-1 text-primary" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t-2 border-primary/10 bg-white" data-testid="mobile-menu">
          <nav className="flex flex-col p-4 gap-2">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
                className="py-3 px-3 text-primary font-semibold border-b border-border">
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
